import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import IconButton from '@material-ui/core/IconButton';
import CircularProgress from '@material-ui/core/CircularProgress';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import DeleteIcon from '@material-ui/icons/Delete';
import withStyles from '@material-ui/core/styles/withStyles';
import dateformat from 'dateformat';
import { Word } from '../../../containers';
import { WID } from '../../../constants/Language';

const styles = theme => ({
  progress: {
    margin: theme.spacing.unit * 2,
  },
  collapse: {
    overflow: 'auto',
  }
});

class TweetListDialog extends React.Component {  
  render() {
    const {
      classes,
      fullScreen,
      open,
      tweetList,
      page,
      rowsPerPage,
      openConfirmDialog,
      handleClose,
      handleEnter,
      handleExited,
      handleChangePage,
      handleChangeRowsPerPage,
      handleDelete,
      handleCloseConfirmDialog,
      handleOK,
    } = this.props;
    
    return (
      <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        onEnter={handleEnter}
        onExited={handleExited}
      >
        <DialogTitle id="settings-dialog-title"><Word wid={WID.TWEET_LIST_DIALOG.TITLE}/></DialogTitle>
        <DialogContent>
          {!tweetList && (
          <div style={{textAlign: 'center'}}>
            <CircularProgress className={classes.progress} />
          </div>
          )}
          {tweetList && (
          <div>
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <TableCell><Word wid={WID.TWEET_LIST_DIALOG.SCHEDULE_POST_DATE}/></TableCell>
                  <TableCell><Word wid={WID.TWEET_LIST_DIALOG.TEXT}/></TableCell>
                  <TableCell><Word wid={WID.TWEET_LIST_DIALOG.IMAGE}/></TableCell>
                  <TableCell><Word wid={WID.TWEET_LIST_DIALOG.ACTION}/></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tweetList
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((tweet, index) => {
                var datetime = new Date(tweet.datetime)
                return (
                <TableRow key={index}>
                  <TableCell>{dateformat(datetime, 'yyyy/m/d HH:MM')}</TableCell>
                  <TableCell>{tweet.text}</TableCell>
                  {(() => {
                    if (tweet.image) {
                      return (
                        <TableCell><img src={'data:image/png;base64,' + tweet.image} style={{ width: '100px', height: 'auto', maxWidth: '100px' }} alt={'tweet-' + index}/></TableCell>
                      );
                    }
                    else {
                      return (
                        <TableCell></TableCell>
                      );
                    }
                  })()}
                  <TableCell>
                    <IconButton className={classes.button} aria-label="Delete" onClick={handleDelete(tweet.id)}>
                      <DeleteIcon/>
                    </IconButton>
                  </TableCell>
                </TableRow>
                );
                })}
              </TableBody>
            </Table>
            <TablePagination
              component="div"
              count={tweetList.length}
              rowsPerPage={rowsPerPage}
              page={page}
              backIconButtonProps={{
                'aria-label': 'Previous Page',
              }}
              nextIconButtonProps={{
                'aria-label': 'Next Page',
              }}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary" autoFocus>
            Close
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openConfirmDialog} onClose={handleCloseConfirmDialog}>
        <DialogTitle><Word wid={WID.TWEET_LIST_DIALOG.DELETE_CONFIRM_DIALOG.TITLE}/></DialogTitle>
        <DialogActions>
          <Button onClick={handleOK} color="primary" autoFocus>
            OK
          </Button>
          <Button onClick={handleCloseConfirmDialog} color="primary" autoFocus>
            Canncel
          </Button>
        </DialogActions>
      </Dialog>
      </div>
    );
  }
}

export default withMobileDialog()(withStyles(styles)(TweetListDialog));


// WEBPACK FOOTER //
// ./src/Parts/MenuAppBar/components/TweetListDialog.js